import { Navigate } from "react-router-dom"
import Guests from "../pages/Guests"
import Enroll from "../pages/Enroll"
import Contact from "../pages/Contact"
import News from "../pages/News"
import Agenda from "../pages/Agenda"
import Meeting from "../pages/Meeting"
import Vendors from "../pages/Vendors"
import Media from "../pages/Media"
import Download from "../pages/Download"
import Home from "../pages/Home"
import Notpage from "../pages/404"
import Detail from '../pages/Guests/Detail'
const routes = [
  {
    path: '*',
    element: <Notpage />
  },
  {
    path: '/',
    element: <Navigate to='/home' />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/guests',
    element: <Guests />,
  },
  {
    path: '/guests/detail',
    element: <Detail />
  },
  {
    path: '/enroll',
    element: <Enroll />
  },
  {
    path: '/guests',
    element: <Guests />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/news',
    element: <News />
  },
  {
    path: '/agenda',
    element: <Agenda />
  },
  {
    path: '/meeting',
    element: <Meeting />
  },
  {
    path: '/vendors',
    element: <Vendors />
  },
  {
    path: '/media',
    element: <Media />
  },
  {
    path: '/download',
    element: <Download />
  },

]
export default routes